(() => {
  const root = document.documentElement;
  const main = document.querySelector('#MainContent');
  const template = main?.dataset?.template || '';
  const isIndex = template === 'index' || template.startsWith('index.');
  const isDesignMode = root.classList.contains('shopify-design-mode') || Boolean(window.Shopify?.designMode);
  const assets = window.ANR_RETRO_ASSETS || {};
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let navigating = false;
  if (isDesignMode) return;

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  const storage = {
    set(k, v) { try { sessionStorage.setItem(k, v); } catch (_) {} },
    get(k) { try { return sessionStorage.getItem(k); } catch (_) { return null; } },
    del(k) { try { sessionStorage.removeItem(k); } catch (_) {} }
  };

  const overlay = () => {
    let el = document.querySelector('.anr-tv-transition');
    if (!el) {
      el = document.createElement('div');
      el.className = 'anr-tv-transition';
      el.setAttribute('aria-hidden', 'true');
      el.innerHTML = '<div class="anr-tv-transition__beam"></div><div class="anr-tv-transition__glitch"></div>';
      document.body.append(el);
    }
    return el;
  };

  const eligible = (a, e) => {
    if (!a?.href || a.hasAttribute('download') || a.dataset.anrNoTransition === 'true') return false;
    if (a.target && a.target !== '_self') return false;
    if (e && (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) return false;
    const u = new URL(a.href, location.href);
    if (u.origin !== location.origin) return false;
    if (/^\/checkouts?\b/.test(u.pathname)) return false;
    if (u.pathname === location.pathname && u.search === location.search && u.hash) return false;
    return u.href !== location.href;
  };

  const go = async (href) => {
    if (!href || navigating) return;
    navigating = true;
    root.classList.add('anr-transitioning');
    storage.set('anr:incoming', '1');
    if (reduced) { await sleep(80); location.assign(href); return; }
    const el = overlay();
    el.className = 'anr-tv-transition is-closing';
    await sleep(320);
    el.className = 'anr-tv-transition is-glitching';
    await sleep(110);
    location.assign(href);
  };

  const mountRoute = () => {
    if (!main || isIndex || document.querySelector('.anr-route-frame')) return;
    root.classList.add('anr-retro-route', 'anr-retro-lock');
    const frame = document.createElement('div');
    frame.className = 'anr-route-frame';
    frame.innerHTML = `
      <div class="anr-retro-shell anr-retro-shell--crt" data-shell="monitor">
        <div class="anr-retro-screen anr-retro-screen--crt">
          <nav class="anr-route-frame__hud" aria-label="AntiNRML navigation">
            <a href="/">← HOME</a><span class="anr-route-frame__title"></span><a href="/cart">CART</a>
          </nav>
          <div class="anr-route-frame__mount"></div>
          <div class="anr-retro-noise" aria-hidden="true"></div>
        </div>
        <img class="anr-retro-bezel" alt="" width="1254" height="1254" aria-hidden="true">
      </div>`;
    const title = frame.querySelector('.anr-route-frame__title');
    if (title) title.textContent = document.title.replace(/\s*[|–—-]\s*AntiNRML.*$/i, '').trim() || 'AntiNRML';
    const bezel = frame.querySelector('.anr-retro-bezel');
    if (bezel && assets.crt) bezel.src = assets.crt;
    const mount = frame.querySelector('.anr-route-frame__mount');
    main.parentNode.insertBefore(frame, main);
    mount.append(main);
  };

  const initHome = () => {
    const home = document.querySelector('[data-anr-retro-home]');
    if (!home) return;
    root.classList.add('anr-retro-lock');
    const boot = home.querySelector('[data-anr-boot]');
    const menu = home.querySelector('[data-anr-menu]');
    const start = home.querySelector('[data-anr-start]');
    const links = [...home.querySelectorAll('.anr-menu__link')];
    const focusLink = (n) => {
      if (!links.length) return;
      const i = (n + links.length) % links.length;
      links.forEach((a, idx) => a.setAttribute('aria-current', idx === i ? 'true' : 'false'));
      links[i].focus({ preventScroll: true });
    };
    const showMenu = () => {
      if (!boot || !menu) return;
      boot.hidden = true; menu.hidden = false; focusLink(0);
    };
    start?.addEventListener('click', showMenu);
    home.addEventListener('keydown', (e) => {
      if (!boot?.hidden && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); showMenu(); return; }
      if (menu?.hidden || !links.length) return;
      const current = Math.max(0, links.indexOf(document.activeElement));
      if (e.key === 'ArrowDown' || e.key.toLowerCase() === 's') { e.preventDefault(); focusLink(current + 1); }
      else if (e.key === 'ArrowUp' || e.key.toLowerCase() === 'w') { e.preventDefault(); focusLink(current - 1); }
      else if (e.key === 'Home') { e.preventDefault(); focusLink(0); }
      else if (e.key === 'End') { e.preventDefault(); focusLink(links.length - 1); }
    });
  };

  document.addEventListener('click', (e) => {
    const a = e.target.closest('a');
    if (!a || !a.closest('[data-anr-retro-home], .anr-route-frame') || !eligible(a, e)) return;
    e.preventDefault(); go(a.href);
  });

  const openIncoming = async () => {
    if (storage.get('anr:incoming') !== '1') return;
    storage.del('anr:incoming');
    if (reduced) return;
    const el = overlay();
    el.className = 'anr-tv-transition is-opening';
    await sleep(380);
    el.className = 'anr-tv-transition';
  };

  window.addEventListener('pageshow', (e) => {
    if (e.persisted) { navigating = false; root.classList.remove('anr-transitioning'); }
  });

  mountRoute();
  initHome();
  openIncoming();
})();
